import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import AnnouncementsManagementPage from "@/pages/admin/AnnouncementsManagementPage";

export const Route = createFileRoute("/_admin/admin/announcements")({
  head: () => pageHead("Admin · Announcements", "AKIVA admin · announcements portal.", "/admin/announcements", true),
  component: AnnouncementsManagementPage,
});
